import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

import Ad from '@ifeng-fe/ui_pc_ad';
import { getImage } from '../../../../utils/cutImg';
import { handleAd } from '../../../../utils/utils';
import { addEventListener, Event } from '@ifeng-fe/ui_base';

class PlayerList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        parentColumn: PropTypes.string,
        ad: PropTypes.object,
        isHitBlack: PropTypes.bool,
    };

    state = {
        tabs: [
            {
                title: '相关新闻',
                index: 1,
            },
            {
                title: `${this.props.parentColumn ? this.props.parentColumn : '其他'}新闻`,
                index: 2,
            },
        ],
        currentIndex: 0,
        data: new Array(),
        relatedVideos: new Array(),
        videoStream: new Array(),
        flag: [1],
    };

    event = new Event();
    // insertArr 为广告方想要插入的一组位置，replaceArr 为广告方想要替换的一组位置，adFn 为回调方法
    insert = (insertArr, replaceArr, adFn) => {
        try {
            if (adFn && typeof adFn === 'function') {
                const { data, currentIndex } = this.state;

                // console.log('insertArr', insertArr); // 要插入的数据的索引
                // console.log('replaceArr', replaceArr); // 被替换的数据的索引
                // console.log(data);
                const infoData = [...data[currentIndex]];
                const refs = [];

                // 广告插入，在指定位置后插入广告位数据
                insertArr.forEach(item => {
                    const ref = React.createRef();

                    refs.push({ index: item, ref });

                    infoData.splice(item, 0, { type: 'ad', ref });
                });

                // 广告替换，在指定位置删除原数据，替换为广告位数据
                replaceArr.forEach(item => {
                    const ref = React.createRef();

                    refs.push({ index: item, ref });

                    infoData.splice(item, 1, { type: 'ad', ref });
                });

                // 广告数据整合处理完毕后，更新列表数据
                this.setState(
                    currentIndex === 0
                        ? {
                              relatedVideos: infoData,
                          }
                        : { videoStream: infoData },
                    () => {
                        const dom = {};

                        for (const ref of refs) {
                            dom[ref.index] = ref.ref.current;
                        }

                        adFn(dom);
                    },
                );
                this.setState({});
            }

            return;
        } catch (e) {
            console.error(e);
        }
    };

    // componentDidMount() {
    //     const { relatedVideos, videoStream } = this.props.content;

    //     this.setState({
    //         relatedVideos,
    //         videoStream,
    //     });
    // }
    async componentDidMount() {
        const { relatedVideos, videoStream } = this.props.content;
        const { currentIndex } = this.state;

        this.setState({
            data: [relatedVideos],
        });

        // 插入广告
        try {
            const { ad } = this.props;

            // event 为传入的 event 事件对象，用于广告方绑定事件
            // insert 为我们自定义的广告插入方法
            // const ad = {
            //     data: {},
            //     preload: '',
            //     callback: (data, event, insert) => {
            //         let box1 = document.createElement('div');

            //         box1.innerHTML = '111111';
            //         let box2 = document.createElement('div');

            //         box2.innerHTML = '222222';
            //         // insert([], [0], function(dom) {
            //         //     console.log(dom)
            //         //     dom[0].appendChild(box1);
            //         // });
            //         event.on('init', data => {
            //             // data 为我们触发方法时传参值
            //             console.log(data);
            //             if (data.index === 0) {
            //                 const insertArr = [];

            //                 const replaceArr = [3];

            //                 insert(insertArr, replaceArr, dom => {
            //                     console.log('dom =========', dom);
            //                     dom[3].appendChild(box1);
            //                 });
            //             } else {
            //                 const insertArr = [];

            //                 const replaceArr = [3];

            //                 insert(insertArr, replaceArr, dom => {
            //                     console.log('dom =========', dom);
            //                     dom[3].appendChild(box2);
            //                 });
            //             }
            //         });
            //     },
            // };

            const callback = await handleAd(ad);

            callback(ad.data, this.event, this.insert); // 将自定义广告插入方法传入，这样广告方即可调用
        } catch (e) {
            console.error(e);
        }

        try {
            const { relatedVideos } = this.props.content;

            if (relatedVideos) {
                this.setState(
                    {
                        relatedVideos,
                    },
                    () => {
                        this.adInit({ index: currentIndex, len: relatedVideos.length }); // 数据请求完毕，初始化时触发广告位插入方法，data 为可选的传参值
                    },
                );
            }
        } catch (e) {
            console.error(e);
        }
    }

    adInit = data => {
        try {
            this.event.trigger('init', data); // 触发广告位插入方法
        } catch (e) {
            console.error(e);
        }
    };

    handleTabMouseOver = e => {
        const { flag } = this.state;
        const { videoStream, relatedVideos } = this.props.content;
        const currentIndex = Number(e.currentTarget.attributes['index'].value);

        this.setState({
            currentIndex,
        });

        if (flag.length < 2 && currentIndex === 1) {
            try {
                this.setState(
                    {
                        videoStream,
                        data: [...this.state.data, videoStream],
                        flag: [1, 1],
                    },
                    () => {
                        setTimeout(() => {
                            this.adInit({
                                index: currentIndex,
                                len:
                                    videoStream && Array.prototype.isPrototypeOf(relatedVideos)
                                        ? videoStream.length
                                        : '',
                            });
                        }, 200);
                    },
                );
            } catch (e) {
                console.error(e);
            }
        }
    };

    render() {
        // console.log(this.props.content);
        const { tabs, currentIndex, relatedVideos, videoStream } = this.state;
        let { content } = this.props;

        if (this.props.isHitBlack) {
            content.videoStream = [];
        }

        const listItem = (item, index) => {
            let listItemDom = '';
            const defaultDom = (
                <li key={index}>
                    <a
                        href={
                            item.base62Id
                                ? `${location.href.substring(0, location.href.lastIndexOf('/c/'))}/c/${item.base62Id}`
                                : `${location.href.substring(0, location.href.lastIndexOf('/c/'))}/c/${item.guid}`
                        }
                        title={item.title}>
                        <div className={styles.imgWrapper}>
                            {item.posterUrl && (
                                <img
                                    src={item.posterUrl ? getImage(item.posterUrl, 72, 40) : ''}
                                    title={item.title}
                                    alt={item.title}
                                />
                            )}
                        </div>
                        <div className={styles.txtWrapper}>
                            <em className={index === 0 ? styles.current : ''}>{item.title}</em>
                        </div>
                    </a>
                </li>
            );

            if (item.type === 'ad') {
                listItemDom = <li key={index} ref={item.ref} />;
            } else {
                listItemDom = defaultDom;
            }

            return listItemDom;
        };

        // 播放列表
        const TabList = (
            <section className={styles.tabList}>
                {/* tab切换 */}
                <div className={styles.tabWrapper}>
                    {tabs.map((item, index) => {
                        if (index === 1 && !content.videoStream.length) {
                            return null;
                        }
                        const width = !content.videoStream.length ? '100%' : '150px';

                        return (
                            <div
                                className={`${styles.tabItem} ${currentIndex === index ? styles.current : ''} ${
                                    index === 1 ? styles.lastChild : ''
                                }`}
                                style={{ width }}
                                key={index}
                                index={index}
                                onMouseOver={this.handleTabMouseOver}>
                                {item.title}
                            </div>
                        );
                    })}
                </div>
                {/* 列表 */}
                <div className={styles.listWrapper}>
                    <ul className={styles.scorllList} aria-label={tabs?.[0]?.title} style={{ display: currentIndex === 0 ? 'block' : 'none' }}>
                        {relatedVideos && Array.prototype.isPrototypeOf(relatedVideos) && relatedVideos.length > 0
                            ? relatedVideos.map((item, index) => {
                                  return listItem(item, index);
                              })
                            : null}
                    </ul>
                    {videoStream && Array.prototype.isPrototypeOf(relatedVideos) && videoStream.length > 0 ? (
                        <ul aria-label={tabs?.[1]?.title} className={styles.scorllList} style={{ display: currentIndex === 1 ? 'block' : 'none' }}>
                            {videoStream && Array.prototype.isPrototypeOf(relatedVideos) && videoStream.length > 0
                                ? videoStream.map((item, index) => {
                                      return listItem(item, index);
                                  })
                                : null}
                        </ul>
                    ) : null}
                </div>
            </section>
        );

        return <div>{TabList}</div>;
    }
}

export default errorBoundary(PlayerList);
